// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9b5625ff","884":"c399a9f1"}[chunkId] + ".chunk.js";
};